import apiFetch from '../apiFetch'

export default function changePasswordService (passwords, token) {
  return apiFetch({ endPoint: 'login/changepassword', method: 'POST', body: passwords, token: token })
}
